<template>
  <div class="f-a-buttons" :class="{'flex-wrap': !nowrap}">
    <vs-button v-for="(btn, index) in items" :key="`${btn}_${index}`"
               class="px-3 py-1"
               :class="{
                  'px-5': typeof btn === 'string',
                  'py-2': typeof btn === 'string',
                  'active': selectButton === btn
               }"
               color="#CDCDCD"
               type="border"
               style="box-shadow: none; background-color: transparent"
               :style="{
                 color: selectButton === btn ? '#7E72F2' : '#696D71',
                 fontWeight: selectButton === btn ? 600 : 400,
                 borderColor: selectButton === btn ? '#7E72F2' : '#696D71',
               }"

               @click="onClickButton(btn)">
      <div>
        <feather-icon v-if="btn.feather" class="mt-1" :icon="btn.feather" style="width: 18px; height: 18px;" />
        <span v-else>{{btn}}</span>
      </div>
    </vs-button>
  </div>
</template>

<script>
export default {
  name: "FAButtons",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: String,
    nowrap: Boolean
  },
  computed: {
    selectButton: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
        this.$emit('click', value)
      }
    }
  },
  methods: {
    onClickButton(btn) {
      if (btn.feather) {
        this.selectButton = btn.key;
      } else {
        this.selectButton = btn;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.f-a-buttons {
  display: flex;
  gap: 1rem;
  vs-button {
    padding: 0.5rem 1rem;
  }
}

.active {
  border: #7E72F2;
}
</style>
